export default {
    /* Light */
    lightXsmall: {
        fontWeight: 'light',
        fontSize: 'xs',
        lineHeight: 3
    },
    lightSmall: {
        fontWeight: 'light',
        fontSize: 'sm',
        lineHeight: 5
    },
    lightMedium: {
        fontWeight: 'light',
        fontSize: 'md',
        lineHeight: 6
    },
    lightLarge: {
        fontWeight: 'light',
        fontSize: 'lg',
        lineHeight: 7
    },
    lightXlarge: {
        fontWeight: 'light',
        fontSize: 'xl',
        lineHeight: 8
    },
    light2Xlarge: {
        fontWeight: 'light',
        fontSize: '2xl',
        lineHeight: 9
    },
    light3Xlarge: {
        fontWeight: 'light',
        fontSize: '3xl',
        lineHeight: 11
    },
    light4Xlarge: {
        fontWeight: 'light',
        fontSize: '4xl',
        lineHeight: 14
    },
    light5Xlarge: {
        fontWeight: 'light',
        fontSize: '5xl',
        lineHeight: 17
    },
    light6Xlarge: {
        fontWeight: 'light',
        fontSize: '6xl',
        lineHeight: 19
    },
    light7Xlarge: {
        fontWeight: 'light',
        fontSize: '7xl',
        lineHeight: 19
    },
    light9Xlarge: {
        fontWeight: 'light',
        fontSize: '9xl',
        lineHeight: 25
    },

    /* Book  */
    bookXsmall: {
        fontWeight: 'light',
        fontSize: 'xs',
        lineHeight: 3
    },
    bookSmall: {
        fontWeight: 'normal',
        fontSize: 'sm',
        lineHeight: 5
    },
    bookMedium: {
        fontWeight: 'normal',
        fontSize: 'md',
        lineHeight: 6
    },
    bookLarge: {
        fontWeight: 'normal',
        fontSize: 'lg',
        lineHeight: 7
    },
    bookXlarge: {
        fontWeight: 'normal',
        fontSize: 'xl',
        lineHeight: 8
    },
    book2Xlarge: {
        fontWeight: 'normal',
        fontSize: '2xl',
        lineHeight: 9
    },
    book3Xlarge: {
        fontWeight: 'normal',
        fontSize: '3xl',
        lineHeight: 11
    },
    book4Xlarge: {
        fontWeight: 'normal',
        fontSize: '4xl',
        lineHeight: 14
    },
    book5Xlarge: {
        fontWeight: 'normal',
        fontSize: '5xl',
        lineHeight: 17
    },
    book6Xlarge: {
        fontWeight: 'normal',
        fontSize: '6xl',
        lineHeight: 19
    },

    /* Medium */
    mediumXsmall: {
        fontWeight: 'medium',
        fontSize: 'xs',
        lineHeight: 3
    },
    mediumSmall: {
        fontWeight: 'medium',
        fontSize: 'sm',
        lineHeight: 5
    },
    mediumMedium: {
        fontWeight: 'medium',
        fontSize: 'md',
        lineHeight: 6
    },
    mediumLarge: {
        fontWeight: 'medium',
        fontSize: 'lg',
        lineHeight: 7
    },
    mediumXlarge: {
        fontWeight: 'medium',
        fontSize: 'xl',
        lineHeight: 8
    },
    medium2Xlarge: {
        fontWeight: 'medium',
        fontSize: '2xl',
        lineHeight: 9
    },
    medium3Xlarge: {
        fontWeight: 'medium',
        fontSize: '3xl',
        lineHeight: 11
    },
    medium4Xlarge: {
        fontWeight: 'medium',
        fontSize: '4xl',
        lineHeight: 14
    },
    medium5Xlarge: {
        fontWeight: 'medium',
        fontSize: '5xl',
        lineHeight: 17
    },
    medium6Xlarge: {
        fontWeight: 'medium',
        fontSize: '6xl',
        lineHeight: 19
    },
    contactTiles: {
        fontWeight: 'normal',
        fontSize: '4xl',
        lineHeight: 14
    },
    contactTilesShrinked: {
        fontWeight: 'normal',
        fontSize: '3xl',
        lineHeight: 12
    }
}
